<template>
    <swiper @swiper="onSwiper"
            :lazy="swiperSettings.lazy"
            :spaceBetween="swiperSettings.spaceBetween"
            :slidesPerView="swiperSettings.slidesPerView"
            :pagination='swiperSettings.pagination'
            :navigation="swiperSettings.navigation"
            :breakpoints="swiperSettings.breakpoints"
            class="compare-slider compare-slider--img">
        <template v-slot:container-start>
            <div class="swiper-controls">
                <div class="swiper-button swiper-button-prev"> </div>
                <div class="swiper-pagination"></div>
                <div class="swiper-button swiper-button-next"></div>
            </div>
        </template>
        <swiper-slide v-for="slide in currentCategory" class="compare-slider__item">
            <div class="compare-card">
                <div class="compare-card__top">
                    <a class="compare-card__img" :href="slide.url">
                        <picture class="catalog-card__img-img"><!--desc: 690х690, mob: 275х275 -->
                            <source media="(min-width: 521px)" :srcset="slide.photo">
                            <source media="(max-width: 520px)" :srcset="slide.photo">
                            <img :src="slide.photo" alt="" loading="lazy">
                        </picture>
                        <div class="compare-card__label">
                            <div class="label label--new" v-if="slide.new" title="Новинка">
                                <img src="/local/templates/main/img/svg/new.svg" alt="" loading="lazy">
                            </div>
                            <div class="label label--dimmer" v-if="slide.dimable" title="Ближний свет">
                                <img src="/local/templates/main/img/svg/dimmer.svg" alt="" loading="lazy">
                            </div>
                        </div>
<!--                        <div class="compare-card__fav"></div>-->
                        <div @click.stop="deleteProduct({productId: slide.id})" class="compare-card__del"></div>
                    </a>
                    <a class="compare-card__title" :href="slide.url">{{ slide.name }}</a>
                    <div class="compare-card__price">
                        <span class="price">{{ slide.price || '0' }}&nbsp;<i class="rub">₽</i></span>
                    </div>
                    <div class="compare-card__info">{{ slide.article }}</div>
                </div>
            </div>
        </swiper-slide>
    </swiper>
</template>

<script>
import {Swiper, SwiperSlide} from 'swiper/vue/swiper-vue'
import SwiperCore, {Pagination, Navigation, Controller} from 'swiper';
import {mapActions, mapState} from "vuex";
SwiperCore.use([Pagination, Navigation, Controller]);
export default {
    name: "ImgSlider",
    components: {
        Swiper,
        SwiperSlide,
    },
    props: {
        categoryId: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            imgSlider: null,
            swiperSettings: {
                lazy: {
                    loadPrevNext: true
                },
                spaceBetween: 0,
                slidesPerView: 1,
                pagination: {"type": "fraction", el: ".swiper-controls .swiper-pagination" },
                navigation: {nextEl: '.swiper-controls .swiper-button-next', prevEl: '.swiper-controls .swiper-button-prev'},
                breakpoints: {
                    1000: {
                        slidesPerView: 4,
                    },
                    720: {
                        slidesPerView: 3,
                    },
                    520: {
                        slidesPerView: 2,
                    },
                    420: {
                        slidesPerView: 1,
                    }
			    },
            }
        }
    },
    computed: {
        currentCategory: {
            get() {
                if (this.categoryId) {
                    return this.categories.find(i => i.ID === this.categoryId).items
                } else {
                    return this.productsList
                }
            },
            set(value) {
                this.changeSorting({catId: this.categoryId, items: value})
            }
        },
        ...mapState({
            categories: state => state.categories,
            productsList: state => state.productsList,
        }),
    },
    methods: {
        onSwiper(swiper) {
            this.imgSlider = swiper
        },
        ...mapActions({
            deleteProduct: 'deleteProduct'
        })
    }
}
</script>

<style scoped>

</style>